import { createSelector } from 'reselect'

export const getIsPhoneInUse = createSelector(
  (state) => Boolean(state && state.user && state.user.auth && state.user.auth.isPhoneInUse),
  (isPhoneInUse) => isPhoneInUse
)
